export default Object.freeze({
    USER_HOST: 'https://techmy.aquazor.ru',
    API_HOST: 'https://api.aquazor.ru/api',
    UPDATE_PERIOD: 5000
})




// WEBPACK FOOTER //
// ./src/config.js